import { render, staticRenderFns } from "./ListPost.vue?vue&type=template&id=2671ccc6&"
import script from "./ListPost.vue?vue&type=script&lang=js&"
export * from "./ListPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports